module.exports = __webpack_public_path__ + "static/img/技术支持动态图.25438c2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/技术支持动态图.gif
// module id = sPyM
// module chunks = 3